import { render, staticRenderFns } from "./workStatus.input.vue?vue&type=template&id=2fd9b986"
import script from "./workStatus.input.vue?vue&type=script&lang=js"
export * from "./workStatus.input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports